module.exports = __webpack_public_path__ + "img/Formlabs-form3.362329b6.png";